import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import '../index.css';
import { signIn } from '../modules/NetworkFunction';
import AuthContext from '../contexts/AuthContext';

function Login({ history }) {
  const [state, setState] = React.useState({
    id: '',
    pw: '',
  });
  const { id, pw } = state;
  const onChange = (e) => {
    const { value, name } = e.target;
    setState({
      ...state, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    });
  };
  //const { authState } = React.useContext(AuthContext);
  const { auth, setAuth } = React.useContext(AuthContext);
  const [loginSuccess, setLoginSuccess] = React.useState(false);
  const [isErr, setIsErr] = React.useState(false);
  const [autoLogin, setAutoLogin] = React.useState(false);

  const handlePwSearchBtn = () => {
    history.push({
      pathname: '/pw-search',
    });
  };

  const login = () => {
    setIsErr(false);
    const signInParam = { userMail: id, userPW: pw };
    signIn(
      signInParam,
      (e) => {
        setLoginSuccess(true);
        const mallId = window.localStorage.getItem('mallId');
        if (autoLogin) {
          window.localStorage.setItem('token', e.token);
        } else {
          window.sessionStorage.setItem('token', e.token);
        }
        if (mallId === 'null' || mallId === null) {
          window.localStorage.setItem('mallId', e.member.mallId);
        }
        setAuth(e.token);
      },
      () => {
        history.push({
          pathname: '/mypage/setting',
        });
      },
      (e) => {
        console.log(e);
        setIsErr(true);
      }
    );
  };

  return (
    <div
      style={{
        backgroundColor: '#DDDDDD',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 100,
        paddingBottom: 100,
        height: '100vh',
      }}
    >
      <div
        style={{
          width: 513,
          height: 534,
          borderRadius: 23,
          backgroundColor: '#F9F9F9',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img
          alt="wizmon-logo"
          src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-wizmon-logo-login.png"
          style={{ width: 280, height: 60 }}
        />
        <p style={{ 
          color: '#FF7A00', 
          marginBottom: 10, 
          marginTop: 23, 
          height: '20px', 
          visibility: isErr ? 'visible' : 'hidden' 
        }}>
          아이디와 비밀번호를 확인해주세요.
        </p>
        <form
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          onSubmit={(e) => {
            e.preventDefault();
            login();
          }}
        >
          <input
            placeholder="아이디"
            value={id}
            name="id"
            onChange={onChange}
            type="text"
            style={{
              width: 337,
              height: 50,
              borderRadius: 25,
              paddingLeft: 20,
              paddingRight: 20,
              marginBottom: 15,
              marginTop: 10,
              border: isErr ? '1px solid #FF7A00' : '0.8px solid #CCCCCC',
            }}
            autoComplete="email"
          />
          <input
            placeholder="비밀번호"
            value={pw}
            name="pw"
            onChange={onChange}
            type="password"
            style={{
              width: 337,
              height: 50,
              borderRadius: 25,
              paddingLeft: 20,
              paddingRight: 20,
              marginBottom: 20,
              border: isErr ? '1px solid #FF7A00' : '0.8px solid #CCCCCC',
            }}
            autoComplete="current-password"
          />

          <button
            style={{
              width: 337,
              height: 54,
              borderRadius: 25,
              backgroundColor: '#B5B5B5',
              color: 'white',
              borderWidth: 0,
              marginTop: 25,
              marginBottom: 15,
              fontSize: 22,
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            로그인
          </button>
        </form>
        <div
          style={{
            width: 337,
            display: 'flex',
            height: 22,
            padding: '0 5px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <div
              className="checkbox-list "
              style={{ width: 120, paddingTop: 10, paddingLeft: 0 }}
            >
              <input
                type="checkbox"
                id="auto-login"
                name="login"
                onChange={() => {
                  setAutoLogin(!autoLogin);
                }}
              />
              <label htmlFor="auto-login">
                <span
                  style={{ fontSize: 16, color: '#848484', fontWeight: 400 }}
                >
                  자동로그인
                </span>
              </label>
            </div>
          </div>
          <div
            style={{
              color: '#848484',
              fontSize: '16px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={handlePwSearchBtn}
          >
            비밀번호 찾기
          </div>
        </div>
        <div
          style={{
            marginTop: 42,
            backgroundColor: '#DDD',
            width: '100%',
            height: '1px',
            fontWeight: 'normal',
            cursor: 'pointer',
          }}
        />
        <div
          style={{
            marginTop: 32,
            display: 'flex',
            gap: 24,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              color: '#848484',
              fontSize: 16,
              fontWeight: 'normal',
            }}
          >
            아직 회원이 아니신가요?
          </div>
          <div
            style={{
              color: '#FF7A00',
              fontSize: 16,
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
            onClick={() => {
              history.push({
                pathname: '/signup/privacy',
              });
            }}
          >
            회원가입
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Login);
